import { z } from "zod"

export const CreditTransactionTypeResponse = {
  Purchase: "Purchase",
  Consumption: "Consumption",
  Adjustment: "Adjustment",
  Expired: "Expired",
} as const

export const ProductPriceResponseDataSchema = z.object({
  id: z.string(),
  amount: z.number().nullable(),
  currency: z.string(),
  type: z.enum(["one_time", "recurring"]),
  interval: z.string().nullable(),
  isActive: z.boolean(),
})

export const ExtraCreditsPriceOptionSchema = z.object({
  id: z.string(),
  unit_amount: z.number().nullable(),
  credits: z.number(),
})

export const ProductResponseDataSchema = z.object({
  id: z.string(),
  name: z.string(),
  description: z.string().nullable(),
  credits: z.string().nullable(),
  extraCreditsPrices: z.array(ExtraCreditsPriceOptionSchema),
  isActive: z.boolean(),
  prices: z.array(ProductPriceResponseDataSchema),
})

export const ListProductsResponseDataSchema = z.array(ProductResponseDataSchema)

export const CreateCheckoutLinkResponseDataSchema = z.object({
  url: z.url().nullable(),
})

export const CreateCustomerPortalSessionResponseDataSchema = z.object({
  url: z.url().nullable(),
})

export const SubscriptionInformationResponseDataSchema = z.object({
  stripeCustomerId: z.string().nullable(),
  autoTopUpMonthlyLimit: z.number().nullable(),
  autoTopUpPriceId: z.string().nullable(),
  autoTopUpCreditsAmount: z.number().nullable(),
  subscriptionCreditsRemaining: z.number(),
  packageCreditsRemaining: z.number(),
  subscription: z.object({
    id: z
      .bigint()
      .optional()
      .transform((val) => val?.toString()),
    name: z.string().optional(),
    credits: z.number().optional(),
    autoRenew: z.boolean().optional(),
    startDate: z
      .date()
      .transform((val) => val.toISOString())
      .optional()
      .nullable(),
    endDate: z
      .date()
      .transform((val) => val.toISOString())
      .optional()
      .nullable(),
    currentPeriodStart: z
      .date()
      .transform((val) => val.toISOString())
      .optional()
      .nullable(),
    currentPeriodEnd: z
      .date()
      .transform((val) => val.toISOString())
      .optional()
      .nullable(),
  }),
  creditPackages: z.object({
    active: z.array(
      z.object({
        id: z.bigint().transform((val) => val.toString()),
        credits: z.number(),
        remaining: z.number(),
      }),
    ),
    currentPeriodTopUpsCount: z.number(),
    hasPendingAutoTopUp: z.boolean(),
    isLimitReached: z.boolean(),
  }),
})

export const CreditTransactionResponseDataSchema = z.object({
  id: z.bigint().transform((val) => val.toString()),
  amount: z.number(),
  type: z.enum(CreditTransactionTypeResponse),
  subscription: z
    .object({
      id: z.bigint().transform((val) => val.toString()),
      credits: z.number(),
      autoRenew: z.boolean(),
      startDate: z
        .date()
        .nullable()
        .transform((val) => val?.toISOString()),
      endDate: z
        .date()
        .nullable()
        .transform((val) => val?.toISOString()),
      currentPeriodStart: z
        .date()
        .nullable()
        .transform((val) => val?.toISOString()),
      currentPeriodEnd: z
        .date()
        .nullable()
        .transform((val) => val?.toISOString()),
    })
    .nullable(),
  package: z
    .object({
      id: z.bigint().transform((val) => val.toString()),
      credits: z.number(),
    })
    .nullable(),
  description: z.string().nullable(),
  createdAt: z.date().transform((val) => val.toISOString()),
})

export const CreditTransactionsResponseDataSchema = z.array(CreditTransactionResponseDataSchema)
